<p>ctvetfacials works!</p>
<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: rgb(255, 250, 244)">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h3>CTVET Attendance List</h3>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->

<div class="container mt-4">

  <div class="search-box mb-3">
  <input type="text" [(ngModel)]="searchText" placeholder="Search..." class="form-control" />
</div>

    <div class="table-responsive d-none d-md-block">
      <table class="table table-striped ">
        <thead>
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Date</th>
            <th>Group</th>
            <th>Image</th> 
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let attendance of filterAttendanceList(); let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ attendance.name }}</td>
            <td>{{ attendance.date }}</td>
            <td>{{ attendance.group }}</td>
            <td>
              <img [src]="getImageUrl(attendance.imageName)" alt="{{ attendance.fullname }}" class="student-image" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <mat-paginator [length]="totalRecords" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
    (page)="pageChanged($event)">
  </mat-paginator>

    <div class="d-md-none">
      <div class="card">
        <div class="card-body">
          <div class="scrollable-card">
            <div *ngFor="let attendance of filterAttendanceList(); let i = index" class="attendance-item">
              <h5>{{ attendance.name }}</h5>
              <p><strong>Date  </strong> {{ attendance.date }}</p>
              <p><strong>Group  </strong> {{ attendance.group }}</p>    
              <p>
                <img [src]="getImageUrl(attendance.imageName)" alt="{{ attendance.fullname }}" class="student-image-small"  />
              </p>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  


</div>
</div>
</div>
</mat-sidenav-content>
</mat-sidenav-container>
